const CoordinatorDesk = () => {
    return (
        <div id="coordinator" className="about-message container">
            <div className="message-left">
                <img src="https://picsum.photos/300/352" alt="coordinator" />
            </div>

            <div className="message-right">
                <h2>COORDINATOR'S DESK</h2>
                <h4>A Message from the Coordinator</h4><br />
                <p>Welcome to Nav Jeevan Mission School, Anandnagar.</p>
                <p>
                    As a school coordinator, my responsibility is to ensure effective coordination among the school management, teachers, students and parents and to support the smooth implementation of our academic and co-curricular programmes.
                    At Nav Jeevan Mission School, we believe that every child deserves proper guidance, encouragement and opportunities to learn and grow. We work together to maintain a positive learning environment where students can develop knowledge, confidence, discipline, creativity, leadership and good values.
                </p>
                <p>
                    Our continuous efforts are focused on strengthening teaching and learning, supporting teachers in their responsibilities, monitoring students’ progress and ensuring that school activities are conducted in an organised and meaningful manner.
                </p>
                <p>
                    I sincerely appreciate the cooperation of our teachers, parents and students. Together, we can create an environment where every child is encouraged to learn with enthusiasm, grow with confidence and succeed with integrity.
                </p>
                <h4>With warm regards,<br />Sherly<br/>
                    Coordinator
                    <br />
                    Nav Jeevan Mission School
                    Anandnagar
                </h4>
            </div>
        </div>
    );
};

export default CoordinatorDesk;